module.exports = __webpack_public_path__ + "media/Guidelines.07820d02.mp3";